import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { BodyM, LabelS } from 'atoms/typography';
import { glossary } from 'lib/glossary';

const LogoContainer = styled.div`
  width: var(--triple-unit);
  text-align: center;
`;
const Logo = styled.img`
  height: var(--triple-unit);
`;

export type Props = {
  competition: {
    slug: string;
    name: string;
    pictureUrl: string | null;
    rank?: number | null;
    to: string;
  };
};

export const Competition = ({ competition }: Props) => {
  return (
    <Horizontal>
      <LogoContainer>
        {!!competition.pictureUrl && (
          <Logo src={competition.pictureUrl} alt={competition.name} />
        )}
      </LogoContainer>
      <Vertical gap={0}>
        <BodyM as="p">
          <Link to={competition.to}>{competition.name}</Link>
        </BodyM>
        {!!competition.rank && (
          <LabelS as="p" color="var(--c-nd-600)">
            <FormattedMessage
              id="Seo.team.Competitions.Competition.currentRank"
              defaultMessage="Current rank: {rank}"
              values={{
                rank: (
                  <FormattedMessage
                    {...glossary.ordinal}
                    values={{ ordinal: competition.rank }}
                  />
                ),
              }}
            />
          </LabelS>
        )}
      </Vertical>
    </Horizontal>
  );
};
